import React, { Component } from 'react';

import HelpfulInfoChildPageBase from '../HelpfulInfo/HelpfulInfoChildPageBase';

interface OwnProps {}
interface OwnState {}

class TermsOfService extends Component<OwnProps, OwnState> {
  render() {
    return <HelpfulInfoChildPageBase pageID={1322} />;
  }
}
export default TermsOfService;
